// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".benefits[data-v-15e73b7e] {\n  background-image: radial-gradient(50vw 500px at center -200px, var(--v-accentPurple-base) 0%, rgba(0,0,0,0) 90%);\n}\nimg[data-v-15e73b7e] {\n  max-width: 100%;\n  height: auto;\n}\nhr[data-v-15e73b7e] {\n  max-width: 50px;\n}\n.benefit-card[data-v-15e73b7e] {\n  max-width: 320px;\n}\n.rewards-prompt-container p[data-v-15e73b7e] {\n  max-width: var(--content-max-width);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
